module.exports = __webpack_public_path__ + "img/maps-marker-host.dfc73923.svg";